import { Component, ErrorInfo, ReactNode } from 'react';
import log from 'loglevel'
import Splash from '../pages/Splash';


interface Props {
  children: ReactNode; 
  fallback?: ReactNode; // Optional: custom fallback UI
}

interface State {
  hasError: boolean;
}

/**
 * A basic error boundary
 * TODO: render something useful
 * Currently this will catch and log an error, but UI will still break and show default error page
 */
class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  }

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  componentDidCatch(error:Error, info:ErrorInfo) {    
    log.error('Error Boundary', error, 'Info:', JSON.stringify(info))
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      // TODO: Display splash screen for a few seconds in case error is transient, then add error message
      return <Splash/>
    }
    return this.props.children;
  }
}

export default ErrorBoundary